import styled from 'styled-components';
import { Main } from '../../common/blocks/Main';
import { forTabletLandscapeOnly, forDesktopUp, forTabletPortraitUp } from '../../../utils/mediaqueries';

export const HomePageMain = styled(Main)`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	padding-top: 1em;
	padding-bottom: 1em;
	background: none;
	background-color: #fff;

	${forTabletPortraitUp`
		padding-top: 3em;
		padding-bottom: 5em;
		background-color: ${props => props.theme.dark_grey};
		background: url(${props => props.backgroundSmall}) top no-repeat;
		background-size: cover;
		-webkit-background-size: cover;
		-moz-background-size: cover;
		-o-background-size: cover;
	`}

	${forTabletLandscapeOnly`
		background: url(${props => props.backgroundMedium}) top no-repeat;
		background-size: cover;
		-webkit-background-size: cover;
		-moz-background-size: cover;
		-o-background-size: cover;
	`}

	${forDesktopUp`
		background: url(${props => props.backgroundLarge}) top no-repeat;
		background-size: cover;
		-webkit-background-size: cover;
		-moz-background-size: cover;
		-o-background-size: cover;
	`}
`;
